export default __webpack_public_path__ + "static/plp--blanco--hover-7fb5831cf3922adb16b869ded3759a8f.jpg";